module.exports = __webpack_public_path__ + "img/nbus_container_3_left2.0101a66e.jpg";